import {useMutation, useQueryClient} from '@tanstack/react-query'
import {
    HttpValidateVerificationPhoneCodeOptions,
    httpValidateVerificationPhoneCode
} from '@features/settings/http/settings.http.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient'

export const useValidateVerificationPhoneCode = ({onSuccess}: {onSuccess: () => void}) => {
    const queryClient = useQueryClient()
    return useMutation<unknown, unknown, HttpValidateVerificationPhoneCodeOptions>({
        mutationFn: variables => httpValidateVerificationPhoneCode(variables),
        onError: errorHandler,
        onSuccess: async () => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
            onSuccess()
        }
    })
}
